import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/terms-of-use/hero";
import PP from "../components/terms-of-use/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Local Dentist in Ilkley, West Yorkshire - Terms of Use </title>
        <meta
          name="description"
          content="Review the Terms of Use for Invisalign Ilkley. Understand your rights and responsibilities when accessing our website and using our trusted dental services."
        />
        <link
          rel="canonical"
          href="https://www.invisalign-ilkley.com/terms-of-use"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
